import ComponentesJQuery from '../../../mixins/cifra/ComponentesJQuery';
import axios from '../../../libs/cifra/axios';
import { EVENTO_CONTROLLER_CARGADO } from '../controllers/application_controller';

const URL_INFO_CUADERNO = '/asistencias/info_cuaderno';
// Usa jquery porque los plugins de la pantalla son con jquery
/* global $ */
export default {
  template: '#pasar-lista-gestion-template',
  mixins: [ComponentesJQuery],
  props: ['id', 'redirectUrl', 'usuarioId', 'turno', 'fechaInicioInicial', 'fechaFinInicial', 'diasSemanaInicial'],
  data() {
    return {
      grupoId: null,
      asignatura: null,
      cuaderno: null,
    };
  },
  watch: {
    asignatura() {
      this.cargarCuaderno();
    },
    grupoId() {
      this.$refs.selectAsignatura.load();
    },
  },
  mounted() {
    this.conectarFiltros();
  },
  methods: {
    paramsAsignatura(texto) {
      return {
        q: texto,
        grupo_id: this.grupoId,
      };
    },
    conectarFiltros() {
      $(this.$el).find('#selector-estructura').on(EVENTO_CONTROLLER_CARGADO, (e) => {
        e.detail.controller.component.on('option:selected clear', (_type, selectedId) => {
          this.grupoId = selectedId;
          this.asignatura = null;
        });
      });
    },
    cargarCuaderno() {
      this.cuaderno = null;
      if (!this.grupoId || !this.asignatura) {
        return;
      }

      const params = { grupo_id: this.grupoId, asignatura_id: this.asignatura.id };
      axios.get(URL_INFO_CUADERNO, { params }).then((result) => {
        this.cuaderno = result.data;
      }).catch(() => {
        this.cuaderno = null;
      });
    },
  },
};
